export default __webpack_public_path__ + "8daceb8bd3a6dcba8471e39604c1091b.webp";